import { safeDecodeURIComponent } from '@mygpt/app';
import validator from 'validator';

export const getUrlHashParams = () => {
  const hashParams: any = {};
  let e;
  const a = /\+/g, // Regex for replacing addition symbol with a space
    r = /([^&;=]+)=?([^&;]*)/g,
    d = function (s: any) {
      return safeDecodeURIComponent(s.replace(a, ' '));
    },
    q = (window.location.hash || window.location.search).substring(1);

  while ((e = r.exec(q))) {
    hashParams[d(e[1])] = d(e[2]);
  }

  return hashParams;
};

// 获取首字缩写
export const getNameAbbr = (name: string) => {
  if (!name) return '';
  return name[0].toLocaleUpperCase();
};

// 自动补充url 头部
export const autoCompleteUrlScheme = (paramUrl: string) => {
  let url = paramUrl.trim();
  if (!/^(?:f|ht)tps?:\/\//.test(url)) {
    url = 'https://' + url;
  }
  return url;
};

// 检查是否path
export const checkIsPath = (url: string) => {
  return (
    url.startsWith('/') &&
    validator.isURL(url, {
      require_protocol: false,
      require_host: false,
      require_port: false,
    })
  );
};

// 文件大小转换(Bytes -> KB,GB..)
// formatFileSize(1024); // 输出: "1.00 KB"
// 指定单位
// formatFileSize(1024, true, 'MB'); // 输出: "0.00 MB"
// 不显示单位
// formatFileSize(1024, false); // 输出: "1.00"
// 指定且显示单位
// formatFileSize(1024, false, 'MB'); // 输出: "0.00"
export const formatFileSize = (bytes: number, includeUnit = true, targetUnit?: string, decimalPlaces = 2) => {
  if (bytes === 0) return includeUnit ? '0 Bytes' : '0';

  const units = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  let index = Math.floor(Math.log(bytes) / Math.log(1024));

  if (targetUnit) {
    const targetIndex = units.indexOf(targetUnit);
    if (targetIndex === -1) {
      throw new Error(`Invalid target unit: ${targetUnit}`);
    }
    index = targetIndex;
  }

  const fileSize = bytes / Math.pow(1024, index);
  const result = fileSize.toFixed(decimalPlaces);

  return includeUnit ? `${result} ${units[index]}` : result;
};

// 检查对象是否包含指定值,包括子对象中的值
export const hasValue = (obj: any, value: any) => {
  // 基本数据类型使用 === 检查
  if (typeof obj === 'string' && obj.includes(value)) {
    return true;
  }

  // 如果是对象,递归检查每个键
  if (obj instanceof Object) {
    for (const key in obj) {
      if (hasValue(obj[key], value)) {
        return true;
      }
    }
  }

  // 都不匹配则返回 false
  return false;
};

// textarea 字符串换成数组
export const splitUrl = (urls: string): string[] => {
  return urls
    .trim()
    .split(/\n/)
    .map((url) => url.trim())
    .filter((url) => url !== '');
};

//实现对象深层合并
export const deepMerge = (target: any, source: any) => {
  // 遍历源对象的键
  for (const key in source) {
    // 如果源对象的键也存在于目标对象中
    // 并且类型也是对象,实现深层合并
    if (Object.prototype.hasOwnProperty.call(target, key) && typeof target[key] === 'object') {
      deepMerge(target[key], source[key]);
    } else {
      // 否则只是拷贝属性
      target[key] = source[key];
    }
  }
  return target;
};

// 检查是否是英文
export const checkIsAlphabetic = (value: string) => {
  if (!value) return 'Invalid Name';
  return /^[a-zA-Z]+$/.test(value);
};
